
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ordersApi } from "./RestService";
import { OrderDTO, OrderFilterDTO } from "../interfaces/OrderInterfaces";

const orderService = ordersApi.injectEndpoints({
    endpoints: (builder) => ({
        getOrders: builder.query<OrderDTO[], OrderFilterDTO>({
            query: (filter) => ({
                url: 'api/orders',
                params: filter
            }),
            providesTags: ['Orders']
        }),
        
        // Mexal sync endpoints
        syncMexal: builder.query<Record<string, string>, { dateFrom: string; dateTo: string }>({
            query: ({ dateFrom, dateTo }) => `api/orders/mexal/sync?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        }),
        
        getMexalDocument: builder.query<MexalDocumentDTO, string>({
            query: (marketplaceOrderId) => `api/orders/mexal/document/${marketplaceOrderId}`,
        }),
        
        linkToMexal: builder.mutation<LinkMexalResponse, LinkMexalRequest>({
            query: (body) => ({
                url: 'api/orders/mexal/link',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Orders'],
        }),
        
        getUnlinkedDocuments: builder.query<MexalDocumentDTO[], void>({
            query: () => 'api/orders/mexal/unlinked',
        }),
        
        // Accept Mirakl order
        acceptOrder: builder.mutation<AcceptOrderResponse, { marketplace: string; orderId: string }>({
            query: ({ marketplace, orderId }) => ({
                url: `api/orders/${marketplace}/accept/${orderId}`,
                method: 'POST',
            }),
            // Non invalidiamo qui per evitare refetch mentre il modal è aperto
            // Il refetch viene gestito manualmente alla chiusura del modal
        }),
    }),
});

export interface AcceptOrderResponse {
    success: boolean;
    message: string;
    orderId: string;
}

// Types for Mexal sync
export interface MexalDocumentDTO {
    formattedId: string;
    sigla: string;
    serie: string;
    numero: string;
    date: string;
    note: string;
    marketplaceOrderId: string | null;
}

export interface LinkMexalRequest {
    sigla: string;
    serie: number;
    numero: number;
    marketplaceOrderId: string;
}

export interface LinkMexalResponse {
    success: boolean;
    message: string;
    documentId?: string;
}

export const { 
    useGetOrdersQuery, 
    useLazyGetOrdersQuery,
    useSyncMexalQuery,
    useLazySyncMexalQuery,
    useGetMexalDocumentQuery,
    useLazyGetMexalDocumentQuery,
    useLinkToMexalMutation,
    useGetUnlinkedDocumentsQuery,
    useLazyGetUnlinkedDocumentsQuery,
    useAcceptOrderMutation,
} = orderService;
